<template>
  <config-view v-if="view === VIEWS.CONFIG" />
  <compound-view v-else-if="view === VIEWS.COMPOUND" />
  <modal-view v-else-if="view === VIEWS.MODAL" />
</template>

<script>
import flow from '@/flows';
import { VIEWS } from '@/common/constants.js'

export default {
  components: {
    configView: () => import(/* webpackChunkName: "config" */ '@/views/config'),
    compoundView: () => import(/* webpackChunkName: "compound" */ '@/views/compound'),
    modalView: () => import(/* webpackChunkName: "modal" */ '@/views/modal/index.vue'),
  },
  data() {
    return {
      VIEWS,
    };
  },
  computed: {
    view() {
      const view = flow.view();
      return view;
    },
  },
};
</script>
